import type { PlaceTool } from '../tools/placeTool';
import type {
  PointerDownResult,
  ScenePointerContext,
  ScenePointerInputHandler,
} from './scenePointerInputHandler';
import { deselectAll } from '@/stores/selectionStore';

export class ScenePlaceInputHandler implements ScenePointerInputHandler {
  constructor(private readonly placeTool: PlaceTool) {}

  onPointerDown(context: ScenePointerContext): PointerDownResult {
    if (context.activeTool !== 'place') {
      return 'ignored';
    }

    deselectAll();
    if (!this.placeTool.startDrag(context.raycaster.ray)) {
      return 'handled';
    }

    return 'captured';
  }

  onPointerMove(context: ScenePointerContext): boolean {
    if (!this.placeTool.isDragging()) {
      return false;
    }

    this.placeTool.updateDrag(context.raycaster.ray);
    return true;
  }

  onPointerUp(_context: ScenePointerContext): boolean {
    if (!this.placeTool.isDragging()) {
      return false;
    }

    this.placeTool.finishDrag();
    return true;
  }

  isDragging() {
    return this.placeTool.isDragging();
  }

  cancel() {
    this.placeTool.cancelDrag();
  }
}
